import { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import { cn } from 'utils/shadcn';

export default function ButtonLoader({
  className,
}: {
  className?: string;
}): JSX.Element {
  return <Loader2 className={cn('mr-2 h-4 w-4 animate-spin', className)} />;
}
